import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button'

import { MdOutlineDownloadForOffline } from 'react-icons/md'
import { FaSpinner } from 'react-icons/fa'

import DownloadBoards from './DownloadBoards'
import '@reach/menu-button/styles.css'
import DownloadExcelFiles from './DownloadExcelFiles'
import DownloadModals from './DownloadModals'
import DownloadViewImages from './DonwloadViewImages'
import DownloadAuthorTextFiles from './DownloadAuthorTextFiles'

const DownloadOptions = () => {
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(null)
  const { t } = useTranslation('proposals')

  return (
    <div>
      <MenuWrapper>
        <StyledMenu>
          <StyledMenuButton>
            <span>{t('Download options')}</span>
            {loading ? (
              <Spinner />
            ) : (
              <MdOutlineDownloadForOffline
                style={{ width: 22, height: 22, marginRight: 5 }}
              />
            )}
          </StyledMenuButton>
          <StyledMenuList>
            <StyledMenuItem onSelect={() => {}}>
              <DownloadBoards setLoading={setLoading} setError={setError} />
            </StyledMenuItem>
            <StyledMenuItem onSelect={() => {}}>
              <DownloadExcelFiles setLoading={setLoading} setError={setError} />
            </StyledMenuItem>
            <StyledMenuItem onSelect={() => {}}>
              <DownloadModals setLoading={setLoading} setError={setError} />
            </StyledMenuItem>
            <StyledMenuItem onSelect={() => {}}>
              <DownloadViewImages setLoading={setLoading} setError={setError} />
            </StyledMenuItem>
            <StyledMenuItem onSelect={() => {}}>
              <DownloadAuthorTextFiles
                setLoading={setLoading}
                setError={setError}
              />
            </StyledMenuItem>
          </StyledMenuList>
        </StyledMenu>
      </MenuWrapper>
      {error && <StyledError>{error}</StyledError>}
    </div>
  )
}

export default DownloadOptions

const MenuWrapper = styled.div`
  position: relative;
  width: fit-content;
`

const StyledMenu = styled(Menu)`
  width: 100%;
`

const StyledMenuButton = styled(MenuButton)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d8e0e4;
  border-radius: 5px;
  min-width: 250px;
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
  background-color: #3f51b5;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #303e8e;
  }
`

const StyledMenuList = styled(MenuList)`
  width: 100%;
  min-width: 300px;
  padding: 0;
  overflow: hidden;
  background-color: #d8e0e4;
`

const StyledMenuItem = styled(MenuItem)`
  width: 100%;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 18px;

  &:not(:first-child) {
    padding-top: 10px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #404040;
  }

  &[data-selected] {
    color: #fff;
    background-color: #3f51b5;
  }
`

const StyledError = styled.p`
  color: red;
  margin-top: 10px;
`

const Spinner = styled(FaSpinner)`
  width: 22px;
  height: 22px;
  margin-right: 5px;
  animation: spin 1s infinite linear;

  @keyframes spin {
    from {
      transform: scale(1) rotate(0deg);
    }
    to {
      transform: scale(1) rotate(360deg);
    }
  }
`
